import { render, staticRenderFns } from "./CustomerGroupAdd.vue?vue&type=template&id=5bba8b9c&"
import script from "./CustomerGroupAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroupAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports